import { useEffect, useState, useCallback } from 'react';

export const useAlpiCutoffHeight = (loadMoreButtonTestGroup, hasMorePages, alpiList) => {
    const [cutoffHeight, setCutoffHeight] = useState(0);

    const calculateAlpiHeight = (firstAlpi) => {
        const rect = firstAlpi.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(firstAlpi);
        const marginTop = parseFloat(computedStyle.marginTop) || 0;
        const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
        const totalHeight = rect.height + marginTop + marginBottom;
        return {rect, totalHeight: totalHeight};
    }

    const calculateCutoffHeight = useCallback(() => {
        const wrapper = document.querySelector('.alpi-list__wrapper');
        const allAlpis = wrapper?.querySelectorAll('[jsh-alpi]');

        if (wrapper && allAlpis && allAlpis.length > 0) {
            const firstAlpi = allAlpis[0];
            const lastAlpi = allAlpis[allAlpis.length - 1];
            const {totalHeight: totalHeightFirst} = calculateAlpiHeight(firstAlpi);
            const {totalHeight: totalHeightLast} = calculateAlpiHeight(lastAlpi);

            // Measure from top of first alpi to bottom of last alpi (including margins)
            const firstAlpiTop = firstAlpi.getBoundingClientRect().top;
            const lastAlpiBottom = lastAlpi.getBoundingClientRect().bottom;
            const lastAlpiMarginBottom = parseFloat(window.getComputedStyle(lastAlpi).marginBottom) || 0;
            const totalContentHeight = (lastAlpiBottom - firstAlpiTop) + lastAlpiMarginBottom;

            // Show all content, then subtract half of last alpi height to cut last row in half
            const height = totalContentHeight - ((totalHeightLast + lastAlpiMarginBottom) / 2);
            setCutoffHeight(height);
        }
    }, []);
    useEffect(() => {
        if(!hasMorePages){
            setCutoffHeight(null);
        }
    }, [hasMorePages]);

    useEffect(() => {
        if (loadMoreButtonTestGroup && hasMorePages) {
            calculateCutoffHeight();

            // Set up intersection observer for load more button
            const loadMoreButton = document.getElementById('load-more-button');

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            calculateCutoffHeight();
                        }
                    });
                },
                {
                    rootMargin: '200px', // Trigger when button is 200px away from viewport
                    threshold: 0
                }
            );

            if (loadMoreButton) {
                observer.observe(loadMoreButton);
            }

            window.addEventListener('resize', calculateCutoffHeight);

            return () => {
                window.removeEventListener('resize', calculateCutoffHeight);
                if (loadMoreButton) {
                    observer.unobserve(loadMoreButton);
                }
                observer.disconnect();
            };
        }
    }, [loadMoreButtonTestGroup, hasMorePages, alpiList, calculateCutoffHeight]);

    return cutoffHeight;
};
